// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
}

.content-title {
  font-size: 18px !important;
  margin: 1em 0 !important;
  font-weight: bold !important;
}

.content-description {
  font-size: 16px !important;
  line-height: 1.5 !important;
  margin: 0.5em 0 !important;
}

.free {
  background-color: #c8ffcd;
  color: darkgreen;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.freetrial {
  background-color: #f3e7a8;
  color: #614d21;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.paid {
  background-color: #ffd3d9;
  color: #482e32;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.freemium {
  background-color: #e9cdfc;
  color: #612887;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.pending {
  background-color: #c7d7df;
  color: #34361c;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.generated {
  background-color: #c8ffcd;
  color: darkgreen;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.in_progress {
  background-color: #fbfbaf;
  color: #646420;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.primarychip {
  background-color: #d7dffa;
  color: #000;
  padding: 5px;
  border-radius: 15%;
  text-transform: capitalize;
  font-size: small;
}

.sun-editor .se-dialog .se-dialog-inner .se-dialog-content {
  top: 200px;
}

/*  THEME VARIABLES FOR DARK MODE  */
.suneditor-wrapper.theme-dark .sun-editor {
  --se-background-color: #212b36;
  --se-text-color: #ffffff;
  --se-border-color: #ccc;
  --se-toolbar-bg: #212b36;
  --se-icon-color: rgba(255, 255, 255, 0.7);
  --se-icon-bg: #212b36;
  --se-icon-hover-bg: #444;
}

/*  THEME VARIABLES FOR LIGHT MODE  */
.suneditor-wrapper.theme-light .sun-editor {
  --se-background-color: white;
  --se-text-color: #000000;
  --se-border-color: #ccc;
  --se-toolbar-bg: white;
  --se-icon-color: rgba(0, 0, 0, 0.7);
  --se-icon-bg: transparent;
  --se-icon-hover-bg: #e0e0e0;
}

/*  CORE EDITOR CONTAINER  */
.sun-editor {
  background-color: var(--se-background-color) !important;
  color: var(--se-text-color) !important;
  border-color: #ccc;
}

/*  TOOLBAR AREA  */
.sun-editor .se-toolbar {
  background-color: var(--se-toolbar-bg) !important;
  border-color: #ccc;
}

/*  MAIN CONTENT WRAPPER  */
.sun-editor .se-wrapper,
.sun-editor .se-wrapper-inner,
.sun-editor .se-wrapper .se-wrapper-inner,
.sun-editor .se-wrapper .se-wrapper-inner .se-wrapper-content,
.sun-editor .se-wrapper .se-wrapper-inner .se-wrapper-content [contenteditable=true] {
  background-color: var(--se-background-color) !important;
  color: var(--se-text-color) !important;
  border-color: #ccc;
}

/*  TOOLBAR BUTTONS  */
.sun-editor .se-btn {
  background-color: var(--se-icon-bg) !important;
  color: var(--se-icon-color) !important;
}

.sun-editor .se-btn:hover {
  background-color: var(--se-icon-hover-bg) !important;
}

.sun-editor .se-btn svg {
  fill: var(--se-icon-color) !important;
}

/*  CONTROLLER BUTTON GROUP (e.g. inline popups)  */
.sun-editor .se-controller .se-btn-group {
  background-color: var(--se-toolbar-bg) !important;
}

.sun-editor .se-controller .se-btn-group button {
  color: var(--se-icon-color) !important;
}

/*  DROPDOWN LAYERS  */
.sun-editor .se-list-layer {
  background-color: var(--se-background-color) !important;
  color: var(--se-icon-color) !important;
}

/*  GENERIC BUTTON OVERRIDE  */
.sun-editor button {
  color: var(--se-icon-color) !important;
}

/*  DEFAULT VALUE DROPDOWNS (like font size)  */
.sun-editor .se-btn-list.default_value {
  background-color: var(--se-background-color) !important;
  color: var(--se-icon-color) !important;
}

/*  DIALOG WINDOWS (like insert image/link)  */
.sun-editor .se-dialog .se-dialog-inner .se-dialog-content {
  background-color: var(--se-background-color) !important;
  color: var(--se-text-color) !important;
}

.sun-editor .se-dialog button,
.sun-editor .se-dialog input,
.sun-editor .se-dialog label {
  background-color: var(--se-background-color) !important;
  color: var(--se-text-color) !important;
}

/*  ACTIVE TABS IN DIALOG  */
.sun-editor .se-dialog-tabs button.active {
  background-color: rgba(255, 255, 255, 0.3764705882) !important;
  color: var(--se-icon-color) !important;
}

/*  FORMATTING DROPDOWN   */
.sun-editor .se-list-layer.se-list-format ul .se-btn-list[data-value=h1] {
  color: white !important;
}

.sun-editor .se-dialog .se-dialog-inner .se-link-preview {
  color: white !important;
}

/*SUBMIT BUTTON ON DIALOG*/
.sun-editor .se-dialog .se-dialog-inner .se-dialog-content .se-btn-primary {
  background-color: #0735e3 !important;
  color: white !important;
  font-weight: bold !important;
  border: none;
}

/*  ACTIVE & HOVER STATES IN DROPDOWN LISTS AND BUTTON  */
.sun-editor .se-list-inner .se-list-basic li button.active {
  background-color: rgba(128, 189, 255, 0.5019607843) !important;
  border: none !important;
}

.sun-editor .se-list-inner .se-list-basic li button:hover {
  background-color: rgba(128, 189, 255, 0.2941176471) !important;
  border: none !important;
}

.sun-editor .se-dialog .se-dialog-inner .se-dialog-content .se-btn-primary:hover {
  background-color: #e9dff9 !important;
  color: #0735e3 !important;
}

.table_main_div .css-3af8sj {
  padding-right: 30px !important;
}
.table_main_div .css-1r1t6oq-MuiSelect-select-MuiInputBase-input-MuiInput-input {
  padding-right: 30px !important;
}

.simplebar-content .css-122q7gy {
  max-width: 60px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./app/style/global.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,SAAA;AADF;;AAIA;EACE,0BAAA;EACA,wBAAA;EACA,4BAAA;AADF;;AAIA;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;AADF;;AAKA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAFF;;AAMA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAHF;;AAOA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA,oCAAA;AACA;EACE,8BAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yCAAA;EACA,qBAAA;EACA,wBAAA;AAJF;;AAOA,qCAAA;AACA;EACE,4BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mCAAA;EACA,yBAAA;EACA,2BAAA;AAJF;;AAOA,4BAAA;AACA;EACE,uDAAA;EACA,sCAAA;EACA,kBAAA;AAJF;;AAOA,mBAAA;AACA;EACE,iDAAA;EACA,kBAAA;AAJF;;AAOA,2BAAA;AACA;;;;;EAKE,uDAAA;EACA,sCAAA;EACA,kBAAA;AAJF;;AAOA,sBAAA;AACA;EACE,8CAAA;EACA,sCAAA;AAJF;;AAOA;EACE,oDAAA;AAJF;;AAOA;EACE,qCAAA;AAJF;;AAOA,mDAAA;AACA;EACE,iDAAA;AAJF;;AAOA;EACE,sCAAA;AAJF;;AAOA,sBAAA;AACA;EACE,uDAAA;EACA,sCAAA;AAJF;;AAOA,8BAAA;AACA;EACE,sCAAA;AAJF;;AAOA,+CAAA;AACA;EACE,uDAAA;EACA,sCAAA;AAJF;;AAOA,8CAAA;AACA;EACE,uDAAA;EACA,sCAAA;AAJF;;AAOA;;;EAGE,uDAAA;EACA,sCAAA;AAJF;;AAOA,4BAAA;AACA;EACE,8DAAA;EACA,sCAAA;AAJF;;AAOA,2BAAA;AACA;EACE,uBAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA,0BAAA;AACA;EACE,oCAAA;EACA,uBAAA;EACA,4BAAA;EACA,YAAA;AAJF;;AAOA,yDAAA;AACA;EACE,8DAAA;EACA,uBAAA;AAJF;;AAOA;EACE,8DAAA;EACA,uBAAA;AAJF;;AAOA;EACE,oCAAA;EACA,yBAAA;AAJF;;AAQE;EACE,8BAAA;AALJ;AAOE;EACE,8BAAA;AALJ;;AASA;EACE,eAAA;EACA,WAAA;AANF","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n}\n\n.content-title {\n  font-size: 18px !important;\n  margin: 1em 0 !important;\n  font-weight: bold !important;\n}\n\n.content-description {\n  font-size: 16px !important;\n  line-height: 1.5 !important;\n  margin: 0.5em 0 !important;\n}\n\n.free {\n  background-color: #c8ffcd;\n  color: darkgreen;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.freetrial {\n  background-color: #f3e7a8;\n  color: #614d21;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.paid {\n  background-color: #ffd3d9;\n  color: #482e32;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.freemium {\n  background-color: #e9cdfc;\n  color: #612887;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.pending {\n  background-color: #c7d7df;\n  color: #34361c;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.generated {\n  background-color: #c8ffcd;\n  color: darkgreen;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.in_progress {\n  background-color: #fbfbaf;\n  color: #646420;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.primarychip {\n  background-color: #d7dffa;\n  color: #000;\n  padding: 5px;\n  border-radius: 15%;\n  text-transform: capitalize;\n  font-size: small;\n}\n\n.sun-editor .se-dialog .se-dialog-inner .se-dialog-content {\n  top: 200px;\n}\n\n/*  THEME VARIABLES FOR DARK MODE  */\n.suneditor-wrapper.theme-dark .sun-editor {\n  --se-background-color: #212b36;\n  --se-text-color: #ffffff;\n  --se-border-color: #ccc;\n  --se-toolbar-bg: #212b36;\n  --se-icon-color: rgba(255, 255, 255, 0.7);\n  --se-icon-bg: #212b36;\n  --se-icon-hover-bg: #444;\n}\n\n/*  THEME VARIABLES FOR LIGHT MODE  */\n.suneditor-wrapper.theme-light .sun-editor {\n  --se-background-color: white;\n  --se-text-color: #000000;\n  --se-border-color: #ccc;\n  --se-toolbar-bg: white;\n  --se-icon-color: rgba(0, 0, 0, 0.7);\n  --se-icon-bg: transparent;\n  --se-icon-hover-bg: #e0e0e0;\n}\n\n/*  CORE EDITOR CONTAINER  */\n.sun-editor {\n  background-color: var(--se-background-color) !important;\n  color: var(--se-text-color) !important;\n  border-color: #ccc;\n}\n\n/*  TOOLBAR AREA  */\n.sun-editor .se-toolbar {\n  background-color: var(--se-toolbar-bg) !important;\n  border-color: #ccc;\n}\n\n/*  MAIN CONTENT WRAPPER  */\n.sun-editor .se-wrapper,\n.sun-editor .se-wrapper-inner,\n.sun-editor .se-wrapper .se-wrapper-inner,\n.sun-editor .se-wrapper .se-wrapper-inner .se-wrapper-content,\n.sun-editor .se-wrapper .se-wrapper-inner .se-wrapper-content [contenteditable=true] {\n  background-color: var(--se-background-color) !important;\n  color: var(--se-text-color) !important;\n  border-color: #ccc;\n}\n\n/*  TOOLBAR BUTTONS  */\n.sun-editor .se-btn {\n  background-color: var(--se-icon-bg) !important;\n  color: var(--se-icon-color) !important;\n}\n\n.sun-editor .se-btn:hover {\n  background-color: var(--se-icon-hover-bg) !important;\n}\n\n.sun-editor .se-btn svg {\n  fill: var(--se-icon-color) !important;\n}\n\n/*  CONTROLLER BUTTON GROUP (e.g. inline popups)  */\n.sun-editor .se-controller .se-btn-group {\n  background-color: var(--se-toolbar-bg) !important;\n}\n\n.sun-editor .se-controller .se-btn-group button {\n  color: var(--se-icon-color) !important;\n}\n\n/*  DROPDOWN LAYERS  */\n.sun-editor .se-list-layer {\n  background-color: var(--se-background-color) !important;\n  color: var(--se-icon-color) !important;\n}\n\n/*  GENERIC BUTTON OVERRIDE  */\n.sun-editor button {\n  color: var(--se-icon-color) !important;\n}\n\n/*  DEFAULT VALUE DROPDOWNS (like font size)  */\n.sun-editor .se-btn-list.default_value {\n  background-color: var(--se-background-color) !important;\n  color: var(--se-icon-color) !important;\n}\n\n/*  DIALOG WINDOWS (like insert image/link)  */\n.sun-editor .se-dialog .se-dialog-inner .se-dialog-content {\n  background-color: var(--se-background-color) !important;\n  color: var(--se-text-color) !important;\n}\n\n.sun-editor .se-dialog button,\n.sun-editor .se-dialog input,\n.sun-editor .se-dialog label {\n  background-color: var(--se-background-color) !important;\n  color: var(--se-text-color) !important;\n}\n\n/*  ACTIVE TABS IN DIALOG  */\n.sun-editor .se-dialog-tabs button.active {\n  background-color: rgba(255, 255, 255, 0.3764705882) !important;\n  color: var(--se-icon-color) !important;\n}\n\n/*  FORMATTING DROPDOWN   */\n.sun-editor .se-list-layer.se-list-format ul .se-btn-list[data-value=h1] {\n  color: white !important;\n}\n\n.sun-editor .se-dialog .se-dialog-inner .se-link-preview {\n  color: white !important;\n}\n\n/*SUBMIT BUTTON ON DIALOG*/\n.sun-editor .se-dialog .se-dialog-inner .se-dialog-content .se-btn-primary {\n  background-color: #0735e3 !important;\n  color: white !important;\n  font-weight: bold !important;\n  border: none;\n}\n\n/*  ACTIVE & HOVER STATES IN DROPDOWN LISTS AND BUTTON  */\n.sun-editor .se-list-inner .se-list-basic li button.active {\n  background-color: rgba(128, 189, 255, 0.5019607843) !important;\n  border: none !important;\n}\n\n.sun-editor .se-list-inner .se-list-basic li button:hover {\n  background-color: rgba(128, 189, 255, 0.2941176471) !important;\n  border: none !important;\n}\n\n.sun-editor .se-dialog .se-dialog-inner .se-dialog-content .se-btn-primary:hover {\n  background-color: #e9dff9 !important;\n  color: #0735e3 !important;\n}\n\n.table_main_div .css-3af8sj {\n  padding-right: 30px !important;\n}\n.table_main_div .css-1r1t6oq-MuiSelect-select-MuiInputBase-input-MuiInput-input {\n  padding-right: 30px !important;\n}\n\n.simplebar-content .css-122q7gy {\n  max-width: 60px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
